import * as actionType from "../constants/actionTypes";

const dashboardReducer = (state = { dashboardData: null }, action) => {
  switch (action.type) {
    case actionType.TOTALUSERS:
      return { ...state, totalusers: action.payload };
    case actionType.MONTHLYREVENUE:
      return { ...state, monthlyrevenue: action.payload };
    case actionType.TOTALREVENUE:
      return { ...state, totalrevenue: action.payload };
    case actionType.DAILY_REVENUE:
      return { ...state, daily_revenue: action.payload };
    case actionType.SALESDATA:
      return { ...state, sale_data: action.payload };

    default:
      return state;
  }
};

export default dashboardReducer;
